/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateSession} from '../api'

export const useMutationInitiateSession = createReactQueryMutationHook('initiateSession', initiateSession)
